enum RedirectAfterLogin {
  HomePage,
  DiagnosticTest,
  MockTest,
  LearningPath,
  ReferralMockTest,
  HomeAppTutorial,
}
export { RedirectAfterLogin };
